export default "__VITE_ASSET__618496d9__"